"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "corporations-filter-toolbox corporations-filter-toolbox--topmost" };
const _hoisted_2 = ["placeholder"];
const _hoisted_3 = { class: "colonies-filter" };
const _hoisted_4 = ["onClick"];
const _hoisted_5 = ["onClick"];
const _hoisted_6 = ["onClick"];
const _hoisted_7 = ["value"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_PopupPanel = (0, vue_1.resolveComponent)("PopupPanel");
    const _directive_i18n = (0, vue_1.resolveDirective)("i18n");
    return ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_PopupPanel, {
        onClose: _cache[5] || (_cache[5] = ($event) => (_ctx.$emit('close')))
    }, {
        header: (0, vue_1.withCtx)(() => [
            (0, vue_1.createElementVNode)("div", null, [
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("h2", null, [...(_cache[6] || (_cache[6] = [
                        (0, vue_1.createTextVNode)("Colonies", -1)
                    ]))])), [
                    [_directive_i18n]
                ]),
                (0, vue_1.createElementVNode)("div", _hoisted_1, [
                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                        href: "#",
                        onClick: _cache[0] || (_cache[0] = (0, vue_1.withModifiers)(($event) => (_ctx.selectAll('All')), ["prevent"]))
                    }, [...(_cache[7] || (_cache[7] = [
                            (0, vue_1.createTextVNode)("All*", -1)
                        ]))])), [
                        [_directive_i18n]
                    ]),
                    _cache[10] || (_cache[10] = (0, vue_1.createTextVNode)(" | ", -1)),
                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                        href: "#",
                        onClick: _cache[1] || (_cache[1] = (0, vue_1.withModifiers)(($event) => (_ctx.selectNone('All')), ["prevent"]))
                    }, [...(_cache[8] || (_cache[8] = [
                            (0, vue_1.createTextVNode)("None*", -1)
                        ]))])), [
                        [_directive_i18n]
                    ]),
                    _cache[11] || (_cache[11] = (0, vue_1.createTextVNode)(" | ", -1)),
                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                        href: "#",
                        onClick: _cache[2] || (_cache[2] = (0, vue_1.withModifiers)(($event) => (_ctx.invertSelection('All')), ["prevent"]))
                    }, [...(_cache[9] || (_cache[9] = [
                            (0, vue_1.createTextVNode)("Invert*", -1)
                        ]))])), [
                        [_directive_i18n]
                    ]),
                    (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                        placeholder: _ctx.$t('filter'),
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.filterText) = $event))
                    }, null, 8, _hoisted_2), [
                        [vue_1.vModelText, _ctx.filterText]
                    ])
                ])
            ])
        ]),
        default: (0, vue_1.withCtx)(() => [
            (0, vue_1.createElementVNode)("div", null, [
                (0, vue_1.createElementVNode)("div", _hoisted_3, [
                    ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.modules, (module) => {
                        return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                            class: "colonies-filter-list",
                            key: module
                        }, [
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("h2", null, [
                                (0, vue_1.createTextVNode)((0, vue_1.toDisplayString)(_ctx.title(module)), 1)
                            ])), [
                                [_directive_i18n]
                            ]),
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                                href: "#",
                                onClick: (0, vue_1.withModifiers)(($event) => (_ctx.selectAll(module)), ["prevent"])
                            }, [...(_cache[12] || (_cache[12] = [
                                    (0, vue_1.createTextVNode)("All", -1)
                                ]))], 8, _hoisted_4)), [
                                [_directive_i18n]
                            ]),
                            _cache[16] || (_cache[16] = (0, vue_1.createTextVNode)(" | ", -1)),
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                                href: "#",
                                onClick: (0, vue_1.withModifiers)(($event) => (_ctx.selectNone(module)), ["prevent"])
                            }, [...(_cache[13] || (_cache[13] = [
                                    (0, vue_1.createTextVNode)("None", -1)
                                ]))], 8, _hoisted_5)), [
                                [_directive_i18n]
                            ]),
                            _cache[17] || (_cache[17] = (0, vue_1.createTextVNode)(" | ", -1)),
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                                href: "#",
                                onClick: (0, vue_1.withModifiers)(($event) => (_ctx.invertSelection(module)), ["prevent"])
                            }, [...(_cache[14] || (_cache[14] = [
                                    (0, vue_1.createTextVNode)("Invert", -1)
                                ]))], 8, _hoisted_6)), [
                                [_directive_i18n]
                            ]),
                            ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.getColonies(module), (colony) => {
                                return (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("label", {
                                    class: "form-checkbox",
                                    key: colony
                                }, [
                                    (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                                        type: "checkbox",
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.selectedColonies) = $event)),
                                        value: colony
                                    }, null, 8, _hoisted_7), [
                                        [vue_1.vModelCheckbox, _ctx.selectedColonies]
                                    ]),
                                    _cache[15] || (_cache[15] = (0, vue_1.createElementVNode)("i", { class: "form-icon" }, null, -1)),
                                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [
                                        (0, vue_1.createTextVNode)((0, vue_1.toDisplayString)(colony) + " - (" + (0, vue_1.toDisplayString)(_ctx.COLONY_DESCRIPTIONS[colony]) + ")", 1)
                                    ])), [
                                        [_directive_i18n]
                                    ]),
                                    (_ctx.compatibility(colony))
                                        ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                                            key: 0,
                                            class: (0, vue_1.normalizeClass)(_ctx.icon(_ctx.compatibility(colony)))
                                        }, null, 2))
                                        : (0, vue_1.createCommentVNode)("", true)
                                ])), [
                                    [vue_1.vShow, _ctx.include(colony)]
                                ]);
                            }), 128))
                        ]));
                    }), 128))
                ])
            ])
        ]),
        _: 1
    }));
}
